<template>
  <div @click="onReloadPage" class="update">
      <i class="fas fa-arrow-circle-up"></i>
      <strong>{{ Language.say('global.version.title') }}</strong>
      <span>{{ Language.say('global.version.subtitle') }}</span>
  </div>
</template>
<script setup>
import Language from '@/js/Shared/Language/Language';

const onReloadPage = () => {
  document.location.reload();
}

</script>